export const SET_FONTS = 'SET_FONTS';
export const SET_FONT_SIZE = 'SET_FONT_SIZE';
export const LOCK_PRIMARY_FONT = 'LOCK_PRIMARY_FONT';
export const LOCK_SECONDARY_FONT = 'LOCK_SECONDARY_FONT';

export function setFonts(fontObj) {
  return {
    type: SET_FONTS,
    fonts: fontObj
  }
}

export function setFontSize(size) {
  return {
    type: SET_FONT_SIZE,
    size: size
  }
}

export function lockPrimaryFont(fontName) {
  return {
    type: LOCK_PRIMARY_FONT,
    name: fontName
  }
}

export function lockSecondaryFont(fontName) {
  return {
    type: LOCK_SECONDARY_FONT,
    name: fontName
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/fonts.js